import { gql } from '@apollo/client'
import { MutationBaseOptions } from '@apollo/client/core/watchQueryOptions'
import { FetchResult } from '@apollo/client/link/core'
import getApolloClient from 'graphql/client'
import { ID } from 'utils/id'

interface Data {
  upload: {
    url: string
  }
}

interface Variables {
  id: ID
  finished: boolean
}

const MUTATION = gql`
    mutation uploadQuantitativeAnalytics($id: ID!, $finished: Boolean!) {
        upload: uploadQuantitativeAnalytics(id: $id, finished: $finished) {
            url
        }
    }
`

export const quantitativeAnalyticsUploadMutate = (
  options: MutationBaseOptions<Data, Variables> = {},
): Promise<FetchResult<Data>> => {
  const oldUpdate = options.update
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: 'searchQuantitativeAnalytics',
    })
    cache.gc()

    if (oldUpdate) {
      oldUpdate(cache, result, options)
    }
  }

  return getApolloClient().mutate<Data, Variables>({
    ...options,
    mutation: MUTATION,
  })
}
